import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import { ROTATION_TABLE } from 'frontend/constants/callers'
import { ROTATION_TABLE_FILTERS } from 'frontend/constants/filterUrls'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const RotationTableDetailPage = () => import('frontend/pages/rotationTable/RotationTableDetailPage')
const RotationTablePage = () => import('frontend/pages/rotationTable/RotationTablePage')
const RTWorkingTimeReport = () => import('frontend/pages/rotationTable/working-time-report/view/RTWorkingTimeReport')

export default [
  {
    path: '/rotation-table',
    name: DASHBOARD_MODULE_TOKENS.rotationTable.name,
    components: {
      default: RotationTablePage,
    },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.rotationTableWorkingTimeReport.name,
        components: {
          header: HeaderFactoryStructure,
          default: RTWorkingTimeReport,
          filters: RemoteFilters,
        },
        props: {
          header: { caller: ROTATION_TABLE, multiple: false },
          default: { caller: ROTATION_TABLE },
          filters: { filterURL: ROTATION_TABLE_FILTERS },
        },
      },
      {
        shownInMenu: true,
        path: 'detail',
        name: DASHBOARD_MODULE_TOKENS.rotationTableDetail.name,
        components: {
          header: HeaderFactoryStructure,
          default: RotationTableDetailPage,
        },
        props: {
          header: { caller: ROTATION_TABLE, multiple: false },
          default: { caller: ROTATION_TABLE },
        },
      },
    ],
  },
]
